module.exports = __webpack_public_path__ + "img/english.04739544.png";